import { Fancybox, Carousel, Panzoom } from "@fancyapps/ui";

(function($) {
  $(function() {
    $('html').removeClass('no-js').addClass('js');

    $('[data-background-images]').responsiveBG();
  });
})(jQuery);
